// extracted by mini-css-extract-plugin
module.exports = {"regimen-finder":"RegimenFinder-module__regimen-finder___2zyK2"};